module.exports = __webpack_public_path__ + "img/thanhsanma.458a0bab.png";